import React, { useState } from "react";
import { TextField, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { validateUser } from "../components/services/userService";
import { AuthDetails } from "../components/models/AuthDetails";
import { AppContext } from "../components/services/AppContext";
import ProgressMessage from "../components/booking/common/ProgressMessage";
import { useLocation } from "react-router-dom";
import Cookies from 'js-cookie';
import "../styles/commonStyle.css";

const OtpValidationPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const phone = location.state?.phone;
  const isLogin = location.state?.isLogin;

  const theme = useTheme();

  const [otp, setOtp] = useState({ value: "", error: "" });
  const [loading, setLoading] = useState(false)

  const handleValidateOtp = async () => {
    const phone = AppContext.phone

    if (!otp || otp.value.length < 6) {
      setOtp({ value: '', error: "Please enter valid OTP!" });
      return;
    }

    console.log("Validating OTP:", otp, phone);
    setLoading(true)


    setTimeout(async () => {
      const authDetails: AuthDetails = await validateUser(phone, otp.value);
      console.log(authDetails);

      if (authDetails.authToken === "") {
        let otpError = authDetails.message;
        setOtp({ ...otp, error: otpError });
        setLoading(false)
        return;
      }
      if (authDetails && authDetails?.userId) {
        AppContext.authDetails = authDetails;
        AppContext.loggedUserId = authDetails?.userId;
        AppContext.loggedAuthToken = authDetails.authToken;
        Cookies.set('loggedUserId', authDetails.userId, { expires: 7 });
        Cookies.set('loggedAuthToken', authDetails.authToken, { expires: 7 });
      }
      setLoading(false);
      navigate("/");
    }, 3000);

  };

  const handleBackBtn = () => {
    navigate("/login", { state: { phone, isLogin } });
  };

  return (
    <>
      {loading && <ProgressMessage progressMessage={"Validating OTP..."} />}
      <div
        className="d-flex justify-content-center align-items-start px-2 pt-5"
        style={{
          minHeight: '100vh',

          fontFamily: `'Inter', 'Segoe UI', sans-serif`,
        }}
      >

        <div className="w-100 bg-white rounded-4 shadow-sm border px-4 py-4" style={{ maxWidth: '420px' }}>
          <h5 className="fw-bold text-center mb-2 fs-5 textSuccessGreen " >
            OTP Verification
           </h5>

          <p className="text-center text-muted mb-4"
            style={{ fontSize: "0.9rem", lineHeight: 1.5 }}
          >
            We've sent a 6-digit OTP to your WhatsApp number.
         </p>

          <TextField
            fullWidth
            label="OTP"
            placeholder="Enter Your OTP"
            variant="outlined"
            value={otp.value}
            onChange={(e) => setOtp({ value: e.target.value, error: "" })}
            inputProps={{ maxLength: 6 }}
            error={!!otp.error}
            helperText={otp.error}
            className="customTextField mt-1"
          />

          <div className="row mt-4">
            <div className="col-6 pe-1">
              <button
                type="button"
                className="btn w-100 fw-semibold back-button"
                onClick={handleBackBtn}
              >
                Back
            </button>
            </div>

            <div className="col-6 ps-1">
              <button
                type="button"
                className="btn w-100 fw-semibold primary-button"
                onClick={handleValidateOtp}
              >
                Verify OTP
               </button>
            </div>
          </div>
        </div>
      </div>


    </>

  );
};

export default OtpValidationPage;
